var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr-button',_vm._g({staticClass:"button menu-icon-button no-outline",class:{
		'is-active': _vm.isActive,
		'menu-icon-button--disabled': _vm.disabled,
	},attrs:{"aria-label":_vm.isActive ? _vm.activeLabel : _vm.inactiveLabel}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }